import { HelmetProvider } from 'react-helmet-async';

import WalletWrapper from '@/components/layouts/WalletWrapper';
import Pages from '@/pages/Pages';
import MaintenancePage from './components/shared/maintenance/MaintenancePage';
import { useSettingsStore } from './store';

function App() {
  const { settings } = useSettingsStore();

  const showMaintenancePage =
    settings.ui?.maintenance?.type === 'page' &&
    settings.ui?.maintenance?.enabled;

  return (
    <HelmetProvider>
      <WalletWrapper>
        {showMaintenancePage ? <MaintenancePage /> : <Pages />}
      </WalletWrapper>
    </HelmetProvider>
  );
}

export default App;
